import React from 'react'

import Icon from 'components/Icon'
import NextImage from 'components/NextImage'
import Tag from 'components/Tag'
import Typography from 'components/Typography'
import { EventContext } from 'context/EventContext'
import CategoryItem from 'screens/home/components/SoftwareCategories/components/CategoryItem'

import classes from './KnowledgeBase.module.scss'

/** @type {import('./types').default} */
const KnlowledgeBase = ({ item }) => {
  const icon = item.category === 'TOP TOOLS' ? ['ic', 'tools'] : ['ic', 'book', 'reader']
  return (
    <>
      <div className={classes.hubsContainer}>
        <Tag color="purple">
          <Icon icon={icon} className={classes.icon} />
          {item.category.toLocaleLowerCase()}
        </Tag>

        <Typography variant="heading-lg" className={classes.title}>
          {item.title}
        </Typography>
        <EventContext
          value={{
            engagementComponent: 'category_hub',
            engagementDestination: 'go-to_hub-pages',
            engagementDetails: 'list-item_hub-page',
            name: 'engagement_facet_click',
          }}
        >
          <div className={classes.hubsGrid}>
            {item.categoryHubLinkCollection.items.map((categoryItem, i) => (
              <CategoryItem
                category={{ title: categoryItem.title, url: categoryItem.url, icon: categoryItem.icon.split('-') }}
                className={classes.categoryIitem}
                // eslint-disable-next-line react/no-array-index-key
                key={`category-item-${i}`}
              />
            ))}
          </div>
        </EventContext>
      </div>
      <div className={classes.imageContainer}>
        <NextImage src={item.image.url} alt="humb-knowledge-base" className={classes.image} layout="fill" />
      </div>
    </>
  )
}

export default KnlowledgeBase
